// AR-1 转弯检测参数
export const AR1_PARAMS = {
  minGyroAmplitude: 0.1,        // rad/s
  shortTurnThreshold: 500,      // ms
  mediumTurnThreshold: 1500,    // ms
  minTurnInterval: 100,         // ms
  smoothingWindow: 5,           // samples
  confidence: 0.85,
} as const;

// AR-2 转弯分类参数
export const AR2_PARAMS = {
  minGyroAmplitude: 0.1,        // rad/s
  edgeAngleWindow: 10,          // samples
  carvingThreshold: 25,         // degrees
  edgingThreshold: 15,          // degrees
  skiddingGyroVariance: 0.5,    // (rad/s)²
  edgeChangeRateThreshold: 3,   // degrees per point
} as const;

// AR-3 外侧压感参数
export const AR3_PARAMS = {
  idealOutsideRatio: 0.75,
  maxFluctuation: 0.15,
  windowSize: 10,               // min 5
  outsideThreshold: 0.1,        // |gyro z|
  entryThreshold: 0.3,
  exitThreshold: 0.15,
  transferCompleteDelta: 0.1,
  confidence: 0.85,
  minDataPoints: 10,
} as const;

// AR-4 立刃同步率参数
export const AR4_PARAMS = {
  maxLagMs: 100,
  minCorrelation: 0.7,
  windowSize: 15,
  sampleRate: 100,              // Hz
  syncThreshold: 0.8,
  confidenceHigh: 0.95,         // >=10 windows
  confidenceMid: 0.85,          // >=5 windows
  confidenceLow: 0.7,
} as const;

// AR-5 弯形质量参数
export const AR5_PARAMS = {
  minTurnSamples: 20,
  fitTolerance: 0.15,
  cvThreshold: 0.25,
  minTurnPairs: 3,
  segmentGyroThreshold: 0.3,    // rad/s
  confidence: 0.85,
} as const;

// AR-6 评估等级映射
export const AR6_THRESHOLDS = {
  excellent: 90,
  good: 75,
  average: 60,
  belowAverage: 40,
} as const;

// AR-7 摔倒检测参数 (Medium default)
export const AR7_PARAMS = {
  Low: {
    freefallG: 0.6,
    impactG: 2.5,
    stationaryHalfBandG: 0.4,
    freefallMinMs: 100,
    stationaryMinMs: 2000,
    cooldownMs: 5000,
    phaseTimeoutMs: 1000,
  },
  Medium: {
    freefallG: 0.5,
    impactG: 2.0,
    stationaryHalfBandG: 0.5,
    freefallMinMs: 80,
    stationaryMinMs: 1500,
    cooldownMs: 5000,
    phaseTimeoutMs: 1000,
  },
  High: {
    freefallG: 0.4,
    impactG: 1.5,
    stationaryHalfBandG: 0.6,
    freefallMinMs: 60,
    stationaryMinMs: 1000,
    cooldownMs: 5000,
    phaseTimeoutMs: 1000,
  },
} as const;

export const GRAVITY = 9.81; // m/s²

// 综合评分权重
export const SCORE_WEIGHTS = {
  turnShape: 0.55,    // roundness
  symmetry: 0.45,
  turnCount: 0.30,
  balance: 0.25,
  diversity: 0.25,
  intensity: 0.20,
} as const;

// 教练话术禁用词
export const COACH_FORBIDDEN_WORDS = [
  '检测到', '建议', '推荐值', '请', '您',
] as const;
